import { updateObject } from 'utils/updateObject'

const initialState = {
  loading: false,
  loadFailed: false,
}

const setUserInfo = (state, { payload }) =>
  updateObject(state, {
    ...state[payload],
    ...payload.data,
    loading: false,
    loadFailed: true,
  })

const resetUserInfo = () => ({ ...initialState })

const setLoading = (state, { payload }) =>
  updateObject(state, {
    ...state[payload],
    loading: true,
    loadFailed: false,
  })

const setLoadingFail = (state, { payload }) =>
  updateObject(state, {
    ...state[payload],
    loading: false,
    loadFailed: true,
  })

const setLoadingEnd = (state, { payload }) =>
  updateObject(state, {
    ...state[payload],
    loading: false,
    loadFailed: false,
  })
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'USER/SET_USER_INFO':
      return setUserInfo(state, action)
    case 'USER/GET_USER_INFO_FETCH_START':
      return setLoading(state, action)
    case 'USER/GET_USER_INFO_FETCH_FAIL':
      return setLoadingFail(state, action)
    case 'USER/GET_USER_INFO_FETCH_END':
      return setLoadingEnd(state, action)
    case 'USER/RESET_USER_INFO':
      return resetUserInfo()
    default:
      return state
  }
}

export default reducer
